import { useContext } from "react";
import {
  DeepRequired,
  FieldErrorsImpl,
  FieldValues,
  UseFormRegister,
} from "react-hook-form";
import { ApiErrorsContext } from "../../contexts";
import { useApiErrors } from "../../hooks";
import { TCarbonComponentSizeProps } from "../../interfaces-and-types";
import { getApiErrorsByFieldName } from "../../utils";

import { View } from "./View";

interface ITextAreaProps<TFormValues extends FieldValues> {
  name: string;
  label: string;
  helperText?: string;
  infoIconText?: string;
  disabled?: boolean;
  size?: TCarbonComponentSizeProps;
  cols?: string;
  rows?: string;
  placeholder?: string;
  className?: string;
  iconRight?: React.ReactNode;
  containerClassName?: string;
  register: UseFormRegister<TFormValues>;
  errors: FieldErrorsImpl<DeepRequired<TFormValues>>;
}

export function TextArea<TFormValues extends FieldValues>(
  props: ITextAreaProps<TFormValues>
) {
  const { errors, ...rest } = props;

  const { apiErrors } = useApiErrors();

  const apiErrorMessage = getApiErrorsByFieldName(props.name, apiErrors);
  const hookFormErrorMessage =
    errors[props.name] && errors[props.name]?.["message"];

  const combinedErrors = hookFormErrorMessage || apiErrorMessage || "";

  return <View errorMessage={combinedErrors} {...rest} />;
}
